module.exports = __webpack_public_path__ + "media/images/inbox/tab-right-arrow-4a2c662ed54af80cefbcba9019d454c0.svg";